var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxtlabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 20,
    viewBox: "0 0 139 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TXT LABS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7767 19.6685V5.02762H0V0.331491H16.89V5.02762H11.1133V19.6685H5.7767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8296 19.6685L24.4315 9.83426L18.1046 0.331491H24.2389L27.65 5.77348L31.0885 0.331491H37.0852L30.7584 9.77901L37.3603 19.6685H31.226L27.5399 13.8398L23.8263 19.6685H17.8296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0839 19.6685V5.02762H38.3072V0.331491H55.1972V5.02762H49.4205V19.6685H44.0839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1689 19.6685V0.331491H70.5054V14.9724H79.8307V19.6685H65.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5792 19.6685L88.7766 0.193369H93.9206L102.118 19.6685H96.3964L94.9935 16.2155H87.5663L86.1909 19.6685H80.5792ZM89.1342 12.0442H93.453L91.3074 6.54696L89.1342 12.0442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.986 19.6685V0.331491H113.862C116.283 0.331491 117.988 0.939226 119.116 2.07182C119.886 2.8453 120.354 3.8674 120.354 5.19337V5.24862C120.354 7.48619 119.088 8.81215 117.383 9.55801C119.721 10.3315 121.207 11.6575 121.207 14.2818V14.337C121.207 17.6519 118.511 19.6685 113.917 19.6685H103.986ZM109.186 8.03867H112.541C114.164 8.03867 115.072 7.48619 115.072 6.35359V6.29834C115.072 5.24862 114.247 4.64088 112.652 4.64088H109.186V8.03867ZM109.186 15.3591H113.312C114.935 15.3591 115.87 14.7238 115.87 13.5912V13.5359C115.87 12.4862 115.045 11.7956 113.257 11.7956H109.186V15.3591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.215 20C127.804 20 124.558 18.9227 122.193 16.7956L125.163 13.232C127.061 14.7514 129.18 15.5525 131.408 15.5525C132.838 15.5525 133.608 15.0552 133.608 14.2265V14.1713C133.608 13.3702 132.976 12.9282 130.362 12.3204C126.264 11.3812 123.1 10.221 123.1 6.24309V6.18784C123.1 2.59668 125.934 0 130.555 0C133.828 0 136.387 0.883978 138.477 2.56906L135.809 6.35359C134.049 5.1105 132.123 4.44751 130.417 4.44751C129.125 4.44751 128.492 5 128.492 5.69061V5.74586C128.492 6.62983 129.152 7.01657 131.82 7.62431C136.249 8.59116 139 10.0276 139 13.6464V13.7017C139 17.6519 135.892 20 131.215 20Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtlabs);
export default __webpack_public_path__ + "static/media/TXTLABS.5d969b21d9505be58df80c0ec7dba474.svg";
export { ForwardRef as ReactComponent };